import React from "react";
import { Triangle } from "react-loader-spinner";

interface HotelLoaderProps {
  height?: string | number;
  width?: string | number;
  color?: string;
  message?: string;
  fullScreen?: boolean; // when false, container doesn't fill viewport
}

export const HotelLoader: React.FC<HotelLoaderProps> = ({
  height = "80",
  width = "80",
  color = "#3B82F6",
  message,
  fullScreen = true,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: fullScreen ? "100vh" : "auto",
        minHeight: fullScreen ? undefined : "140px",
        gap: "20px",
      }}
    >
      <Triangle
        visible={true}
        height={height}
        width={width}
        color={color}
        ariaLabel="hotel-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
      <div
        style={{
          color: "var(--color-text-primary, #666)",
          fontSize: "16px",
          fontWeight: "500",
          height: "20px",
          visibility: message ? "visible" : "hidden",
        }}
      >
        {message || "Loading"}
      </div>
    </div>
  );
};
